import { useIntl } from 'react-intl';

import { TransactionItem } from './transaction-item';

import styles from './recent-transactions.module.css';

export function RecentTransactions({ transactions }) {
	const intl = useIntl();

	return (
		<div className={styles.card}>
			<h3 className={styles.cardTitle}>
				{intl.formatMessage({ id: 'FinPathDashboardID10' })}
			</h3>
			<div className={styles.list}>
				{transactions.slice(0, 9).map(transaction => (
					<TransactionItem key={transaction.id} transaction={transaction} />
				))}
			</div>
		</div>
	);
}
